export default "__VITE_ASSET__3N8dSHwS__"